import { Component, h, Prop } from "@stencil/core";

@Component({
  tag: "tt-add-to-cart-mini",
  styleUrl: "tt-add-to-cart-mini.scss",
  shadow: true,
})
export class TtAddToCartMini {
  @Prop() ttProductCode: string;
  @Prop() ttOrigin: string;
  @Prop() ttMultiCartEnabled: boolean;
  @Prop() ttMiniFlyout = true;
  /* TTRQ-50439 custom start */
  @Prop() modalHeaderLabel: string;
  @Prop() modalBodyLabel: string;
  @Prop() modalAddToNewWishlistLabel: string;
  /* TTRQ-50439 custom end */
  /* TTRQ-52684 custom start */
  @Prop() createCartLabel: string;
  /* TTRQ-52684 custom end */
  /* TTRQ-54327 custom start */
  @Prop() cartModalHeaderLabel: string;
  @Prop() cartModalBodyLabel: string;
  @Prop() cartModalIncreaseLabel: string;
  @Prop() cartModalNewlineLabel: string;
  @Prop() cartModalCancelLabel: string;
  /* TTRQ-54327 custom end */
  /* TTRQ-48668 Custom Start */
  @Prop() addToCartLable: string;
  @Prop() addToWishlistLable: string;
  /* TTRQ-48668 Custom End */
  @Prop() ttPurchasableForCurrentB2BUnit: boolean;

  render() {
    return (
      <bcp-product-action-container
        class="a-search-suggestions__item-actions"
        productCode={this.ttProductCode}
      >
       {this.ttPurchasableForCurrentB2BUnit && (
        <f-value-modificator
          slot={"quantity-updater"}
          min={1}
        ></f-value-modificator>
         )}
         {this.ttPurchasableForCurrentB2BUnit && (
        <bcp-add-to-cart-new
          slot={"action-buttons"}
          ttFullWidth={false}
          ttIconOnly={true}
          ttOrigin={this.ttOrigin}
          ttMiniFlyout={this.ttMiniFlyout}
          multiCartEnabled={this.ttMultiCartEnabled}
          /* TTRQ-52684 custom start */
          createCartLabel={this.createCartLabel}
          /* TTRQ-52684 custom end */
          productCode={this.ttProductCode}
          /* TTRQ-54327 custom start */
          modalHeaderLabel={this.cartModalHeaderLabel}
          modalBodyLabel={this.cartModalBodyLabel}
          modalIncreaseLabel={this.cartModalIncreaseLabel}
          modalNewLineLabel={this.cartModalNewlineLabel}
          modalCancelLabel={this.cartModalCancelLabel}
          /* TTRQ-54327 custom end */
          cart-label={this.addToCartLable} /* TTRQ-48668 Custom */
        ></bcp-add-to-cart-new>
        )}
        <bcp-add-to-wishlist
          slot={"action-buttons"}
          productCode={this.ttProductCode}
          ttFullWidth={false}
          iconOnly={true}
          /* TTRQ-52362 custom start */
          ttOrigin={this.ttOrigin}
          /* TTRQ-52362 custom end */
          /* TTRQ-50439 custom start */
          modalHeaderLabel={this.modalHeaderLabel}
          modalBodyLabel={this.modalBodyLabel}
          modalAddToNewWishlistLabel={this.modalAddToNewWishlistLabel}
          /* TTRQ-50439 custom end */
          wishlist-label={this.addToWishlistLable} /* TTRQ-48668 Custom */
        ></bcp-add-to-wishlist>
      </bcp-product-action-container>
    );
  }
}
